/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, EventEmitter, inject, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { IsNarrowService } from '@src/app/shared/is-narrow.service';
import { FormConfig } from '@src/app/shared/form/FormConfig';
import { MatMenuModule } from '@angular/material/menu';
import { NgTemplateOutlet } from '@angular/common';
import { OurAppTrackerService } from '@src/app/shared/our-app-tracker-service';
import { IFormAction } from '@src/app/shared/form/form.component';
import { Observable } from 'rxjs';
import { ConfirmDialogService } from '@src/app/shared/dialogs/confirmDialog';
import { AbstractObject } from '@src/app/model/abstract-object';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-form-top-actions',
    imports: [MatMenuModule, NgTemplateOutlet, MatTooltipModule, MatIconModule, MatButtonModule, NgTemplateOutlet],
    templateUrl: './form-top-actions.component.html',
    styleUrl: './form-top-actions.component.scss'
})
export class FormTopActionsComponent implements OnDestroy, OnChanges {
    @Input() config: FormConfig;
    @Input() isPrint: boolean;
    @Input() isEnabled = true;
    @Output() completeEvent: EventEmitter<AbstractObject> = new EventEmitter<AbstractObject>();

    isPhone = false;
    ourAppTracker = inject(OurAppTrackerService);
    cds = inject(ConfirmDialogService);
    screenSvc = inject(IsNarrowService);
    subscriptions = [];


    constructor() {
        this.subscriptions.push(this.screenSvc.detectVeryNarrow().subscribe(result => { this.isPhone = result; }));
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.subscriptions = [];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.isPrint?.currentValue !== undefined) {
            this.isPrint = changes.isPrint.currentValue;
        }
        if (changes.isEnabled?.currentValue !== undefined) {
            this.isEnabled = changes.isEnabled.currentValue;
        }
    }

    getActionCount() {
        return this.config.actions.filter(a => a.show).length;
    }

    getActionTip(a: IFormAction) {
        if (a.tipText && a.icon) {
            return a.name + '. ' + a.tipText;
        } else if (a.tipText) {
            return a.tipText;
        } else {
            return a.name;
        }
    }

    takeAction(a: IFormAction) {
        const currentValue = this.config.fieldSet.getFormValue();
        let action: Observable<AbstractObject>;
        if (a.approvalNeeded) {
            this.cds.open(a.name, a.approvalText, () => {
                this.ourAppTracker.logAction(`Taking Action: ${a?.constructor?.name} - ${a?.name} - ${a?.icon}`);
                action = a.action(currentValue, this.config);
                if (action) {
                    action.subscribe(o => {
                        if (o) {
                            this.completeEvent.emit(o);
                        }
                        this.ourAppTracker.logAction("Action: " + a?.constructor?.name + " completed");
                    });
                }
            }, a.name);
        } else {
            action = a.action(currentValue, this.config);
            this.ourAppTracker.logAction(`Taking Action: ${a?.constructor?.name} - ${a?.name} - ${a?.icon}`);
            if (action) {
                action.subscribe(o => {
                    if (o) {
                        this.completeEvent.emit(o);
                    }
                    this.ourAppTracker.logAction("Action: " + a?.constructor?.name + " completed");
                });
            }
        }
    }
}
